'use strict';

module.exports = /* @ngInject */ ["$q", "authApiFactory", "$log", function ($q,
    authApiFactory,
    $log) {
  var that = this;
  var loginUrlPromise;

  that.getEikonLoginUrl = function () {
    if (!loginUrlPromise) {
      loginUrlPromise = authApiFactory.create().then(function (authApi) {
        return authApi
          .one('eikonsso')
          .one('loginurl')
          .withHttpConfig({ignoreAuthModule: true})
          .get()
          .then(function (loginUrl) {
            return loginUrl.url;
          }, function () {
            $log.error('Error retrieving eikonLoginUrl');
          });
      });
    }
    return loginUrlPromise;
  };
}];


//////////////////
// WEBPACK FOOTER
// /app/~/redi-idp-web-lib/dist/business/eikonLoginUrlRepository.js
// module id = 116
// module chunks = 0